import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LightbulbRegular from './lightbulb-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LightbulbRegular {...validProps} />;
}

SvgComponent.iconName = 'lightbulb-regular';

export const LightbulbRegularIcon = svgIconWrapper(SvgComponent);
